import type { Dispatch, SetStateAction } from "react";
import type { Field } from "./upload_manager";

const CSRF_COOKIE_NAME = "MYGREENHOUSE-XSRF-TOKEN";

function getCsrfToken(): string {
  return (
    document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${CSRF_COOKIE_NAME}=`))
      ?.split("=")[1] ?? ""
  );
}

export default class RailsUploader {
  field: Field;
  private _fileUrl: string = "";
  private _expiresAt: number = 0;
  private _signedId: string = "";

  constructor({ field }: { field: Field }) {
    this.field = field;
  }

  fileUrl() {
    return this._fileUrl;
  }

  expiresAt() {
    return this._expiresAt;
  }

  signedId() {
    return this._signedId;
  }

  async uploadFile(file: File, setPercentage: Dispatch<SetStateAction<number>>) {
    const form = new FormData();
    form.append("file", file);

    return new Promise<void>((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      xhr.upload.onprogress = (event) => {
        setPercentage((event.loaded / event.total) * 100);
      };

      xhr.onloadend = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            const json = JSON.parse(xhr.responseText);
            this._fileUrl = json.url;
            this._expiresAt = Date.parse(json.expires_at);
            this._signedId = json.signed_id ?? "";
            resolve();
          } catch {
            reject(new Error("Upload failed"));
          }
        } else {
          reject(new Error("Upload failed"));
        }
      };

      xhr.onerror = () => reject(new Error("Upload failed"));

      xhr.open("POST", "/job_application_files");
      xhr.setRequestHeader("Accept", "application/json");
      xhr.setRequestHeader("X-CSRF-TOKEN", getCsrfToken());
      xhr.send(form);
    });
  }
}
